webpackJsonp([35783957827783],{

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTwitterWidgets = __webpack_require__(55);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container main-section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-8 level-one' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Paul Kimbrel - Web Developer and Systems Architect, Sound Engineer.' }),
	        _react2.default.createElement(
	          'article',
	          null,
	          _react2.default.createElement(
	            'header',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'About Me'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'I have over 18 years of professional experience in the areas of software application architecture, design and development. I also have over 23 years of experience in computer science. I have been a computer programmer, enthusiast, and evangelist for most of my life and I continue to look for ways to expand my skills and find ways of using technology to make life a little easier for everyone.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'I\'m also very happily married and have three amazing children. Fortunately, my boys have shown interest in many of the same interests that I\'ve had over the years which makes our home a very interesting place. My wife and I (mostly my wife) homeschool our boys and it\'s fun to watch them as they grow and learn.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'My hobbies are plentiful and it seems I\'m always either planning or executing some crazy project. I am doing, have done, or WILL BE doing:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Music (studio engineering, guitar, vocals, sequencing)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Software Development (it\'s not just a career)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Ham Radio (',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://qrz.com/db/kc9jer' },
	                'KC9JER'
	              ),
	              ')'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Electronic Engi*cough* Tinkering'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Legacy Programming (keeping history alive)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Photography'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'article',
	          { className: 'synopsis' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: data.allMarkdownRemark.edges[0].node.fields.slug },
	            _react2.default.createElement(
	              'header',
	              null,
	              _react2.default.createElement(
	                'div',
	                { 'class': 'latest' },
	                'Latest article...'
	              ),
	              _react2.default.createElement(
	                'h2',
	                { className: 'withDate' },
	                data.allMarkdownRemark.edges[0].node.frontmatter.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'time',
	                  { dateTime: data.allMarkdownRemark.edges[0].node.frontmatter.date },
	                  data.allMarkdownRemark.edges[0].node.frontmatter.date
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'excerpt' },
	            data.allMarkdownRemark.edges[0].node.excerpt
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: data.allMarkdownRemark.edges[0].node.fields.slug },
	            'Read more...'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4 level-two' },
	        _react2.default.createElement(_reactTwitterWidgets.Timeline, { dataSource: { sourceType: "profile", screenName: "pkimbrel" },
	          options: { username: "reactjs", height: "500" } })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-260b114402d218894906.js